import { TransactionStatus } from './transactionStatus'

export enum PaymentProvider {
  powercash = 1,
  unlimit = 2,
  emerchantpay = 4,
  noovei = 5,
}

export type KeyInfo = {
  public_key: string
}

export type NextAction = {
  type: 'request_redirect' | 'redirect_link' | 'iframe_link' | 'wait_and_poll'
  data: {
    url: string
    method: string
    headers: Record<string, string>
    payload: string
  }
  created_at: string
}

export type PaymentInfo = {
  next_action: NextAction
  payment_status: TransactionStatus
}

export type InitPaymentRequest = {}

export const paymentProviderNaming: Record<PaymentProvider, string> = {
  [PaymentProvider.powercash]: 'Powercash',
  [PaymentProvider.unlimit]: 'Unlimit',
  [PaymentProvider.emerchantpay]: 'Emerchantpay',
  [PaymentProvider.noovei]: 'Noovei',
}
